export default __webpack_public_path__ + "0ca1b0e9673f166a40a651ee14bd63c5.png";